import { createFileRoute } from '@tanstack/react-router';
import { SetupGuideRedirectRoute } from './-journeys-redirects';

function SetupGuideRoute() {
  const { workspaceId } = Route.useParams();
  return <SetupGuideRedirectRoute workspaceId={workspaceId} />;
}

// The splat covers the bare `/setup-guide` URL too (an empty `_splat`), matching Ember's
// pair of `setup-guide` and `setup-guide/*` registrations.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$')({
  component: SetupGuideRoute,
});
